import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { RegionsState, REGIONS_SLICE_NAME } from './models';

export const regionsSelector = (state: RootState): RegionsState => state[REGIONS_SLICE_NAME];

export const selectRegions = createSelector(regionsSelector, (state: RegionsState) => state.regions);

export const selectQuery = createSelector(regionsSelector, (state: RegionsState) => state.query);

export const selectRegionsIsLoading = createSelector(regionsSelector, (state: RegionsState) => state.isLoading);

export const selectAutoCompleteRegions = createSelector(
  regionsSelector,
  (state: RegionsState) => state.autoCompleteRegions,
);

export const selectAutoCompleteSettlements = createSelector(
  regionsSelector,
  (state: RegionsState) => state.autoCompleteSettlements,
);

export const selectAutoCompletePickups = createSelector(regionsSelector, (state: RegionsState) => state.pickups);
